import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

interface ConfirmModalProps {
  title: string;
  username: string;
  password: string;
  open: boolean;
  onClose: () => void;
}

export default function PasswordModal({
  title,
  username,
  password,
  open,
  onClose,
}: ConfirmModalProps) {
  const onCopyAndClose = () => {
    navigator.clipboard.writeText(
      `username: ${username}, password: ${password}`
    );
    onClose();
  };

  return (
    <Dialog open={open}>
      <DialogTitle>{title}</DialogTitle>
      <Divider />
      <DialogContent sx={{ width: "400px", padding: "20px 24px 0 24px" }}>
        <Grid container direction="column" gap={1}>
          <Grid container>
            <Grid size={{ xs: 4 }}>
              <Typography>ชื่อผู้ใช้</Typography>
            </Grid>
            <Grid size={{ xs: 8 }}>
              <Typography fontWeight={500}>{username}</Typography>
            </Grid>
          </Grid>

          <Grid container>
            <Grid size={{ xs: 4 }}>
              <Typography>รหัสผ่าน</Typography>
            </Grid>
            <Grid size={{ xs: 8 }}>
              <Typography fontWeight={500}>{password}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: "center", padding: "16px 0" }}>
        <Button variant="contained" onClick={onCopyAndClose}>
          คัดลอกและปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
